import React from 'react'
import SearchUI from '../../../widgets/input/SearchUI'
import ProgressUI from '../../../widgets/output/ProgressUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import AvatarAndNameUI from '../../../widgets/output/AvatarAndNameUI'
import LRTableRowLinkUI from '../../../widgets/layout/LRTableRowLinkUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import LabelAndValueUI from '../../../widgets/layout/LabelAndValueUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
// import './BudgetList.css'

const BudgetListUI = ({ context, messageList, budgetList,
  searchFilter, onRefreshClick, onSearchFilterChange, onCreateClick
}) =>
  <div className='bdg_budgets g_m_top_100'>

    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          messageList={messageList}
          onRefreshClick={onRefreshClick}
          onCreateClick={onCreateClick}
        />
      }
      right={
        <ActionTopRightUI
          context={context}
          messageList={messageList}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
        />
      }
    />

    <LRTableBodyUI className='data_tbl'>
      {
        budgetList.map((budget, i) =>
          <BudgetRowUI key={i} context={context} messageList={messageList} budget={budget} />
        )
      }
    </LRTableBodyUI>
  </div>

const BudgetRowUI = ({ context, budget, messageList }) =>
  <LRTableRowLinkUI
    context={context}
    to={`/budgets/${budget.budgetId}`}
    left={<RowLeftUI context={context} messageList={messageList} budget={budget} />}
    right={<RowRightUI context={context} messageList={messageList} budget={budget} />}
  />

const RowLeftUI = ({ context, messageList, budget }) =>
  <div>
    <div>
      {budget.budgetName}
    </div>
    <div className='g_m_top_50'>
      <AvatarAndNameUI avatarUrl={budget.avatarUrl}
        userName={budget.userName} userLeft={budget.userLeft}
      />
    </div>
    <div className='g_m_top_50'>
      <ProgressUI messageList={messageList} labelKey='c_utilized' percent={budget.spentAmountPercent} />
    </div>
  </div>

const RowRightUI = ({ context, messageList, budget }) =>
  <div>
    <LabelAndValueUI messageList={messageList} labelKey='c_allocated' align='right'>
      {budget.assignedAmountF2}
    </LabelAndValueUI>
    <LabelAndValueUI messageList={messageList} labelKey='c_utilized' align='right'>
      {budget.spentAmountF2}
    </LabelAndValueUI>
  </div>

const ActionLeftUI = ({ context, messageList, onRefreshClick, onCreateClick
}) =>
  <div className='g_flex_h'>
    <IconButtonUI messageList={messageList} icon='icon-refresh' onClick={onRefreshClick} labelKey='c_refresh' />
    {
      context.permissions && context.permissions.includes('acc_manage') &&
      <IconButtonUI messageList={messageList} icon='icon-plus' onClick={onCreateClick} labelKey='c_create_budget' />
    }
  </div>

const ActionTopRightUI = ({ context, messageList, searchFilter, onSearchFilterChange
}) =>
  <div className='g_flex_h'>
    <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
  </div>

export default BudgetListUI
